import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesServicesReasonsListComponent } from './cases-services-reasons-list/cases-services-reasons-list.component';
import { CasesServicesReasonsDetailComponent } from './cases-services-reasons-detail/cases-services-reasons-detail.component';

const routes: Routes = [
    {
        path: 'casesServicesReasons',
        children: [
            { path: '', component: CasesServicesReasonsListComponent }
        ]
    },
    {
        path: 'casesServicesReasons/:id',
        children: [
            { path: '', component: CasesServicesReasonsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],

    exports: [RouterModule]
})
export class CasesServicesReasonsRoutingModule { }
